// extracted by mini-css-extract-plugin
export default {"cast":"People_cast__vV-6O"};